"use client";
import { Html } from "@custom/schema";
import clsx from "clsx";
import React from "react";
export default function LifecycleDiagram(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-14 mb-20 md:mb-28"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-w-7xl mx-auto"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "mx-auto max-w-xs md:max-w-xl lg:max-w-2xl text-center block text-2xl md:text-3xl lg:text-4xl mb-14"
    }, props.heading), props.buttons && /*#__PURE__*/ React.createElement("div", {
        className: "text-center -mt-6 mb-14 sm:flex sm:gap-x-6 justify-center"
    }, props.buttons.map(function(cta, key) {
        /*#__PURE__*/ return React.createElement("a", {
            key: key,
            href: cta === null || cta === void 0 ? void 0 : cta.target,
            className: "button-secondary border-gray-600 text-gray-600 hover:bg-gray-600 hover:text-white mb-4 last:mb-0 sm:mb-0"
        }, cta === null || cta === void 0 ? void 0 : cta.label);
    })), /*#__PURE__*/ React.createElement("div", {
        className: "diagram-container relative -left-3.5 min-[350px]:left-0 w-[300px] sm:w-[468px] lg:w-[840px] mx-auto"
    }, /*#__PURE__*/ React.createElement(MainDiagramSvg, null), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap justify-between lg:block w-full"
    }, props.section.map(function(section, key) {
        /*#__PURE__*/ return React.createElement("div", {
            key: key,
            className: "diagram-wrap group inline-block w-full lg:w-auto lg:block text-left"
        }, /*#__PURE__*/ React.createElement("div", {
            className: clsx('diagram-inner group-hover:after:bg-yellow-500 transition-all duration-300 after:transition-all after:duration-300 after:content-[""] after:block after:mt-3.5 after:w-full after:h-1 after:bg-gray-400 mb-6 lg:mb-0 lg:absolute min-w-[120px] lg:min-w-[140px]', {
                "top-3 lg:-right-20 xl:-right-28": (section === null || section === void 0 ? void 0 : section.imageQuadrant) === "northeast",
                "top-3 lg:-left-20 xl:-left-28": (section === null || section === void 0 ? void 0 : section.imageQuadrant) === "northwest",
                "bottom-10 lg:-right-20 xl:-right-28": (section === null || section === void 0 ? void 0 : section.imageQuadrant) === "southeast",
                "bottom-10 lg:-left-20 xl:-left-28": (section === null || section === void 0 ? void 0 : section.imageQuadrant) === "southwest"
            })
        }, /*#__PURE__*/ React.createElement("h3", {
            className: "font-semibold text-left text-lg lg:text-xl lg:mb-1 leading-6 group-hover:text-black text-gray-200 inline-block"
        }, section ? /*#__PURE__*/ React.createElement(Html, {
            markup: section === null || section === void 0 ? void 0 : section.heading
        }) : null), /*#__PURE__*/ React.createElement("p", {
            className: "transition-all lg:max-h-0 lg:opacity-0 group-hover:opacity-100 group-hover:lg:max-h-20 overflow-hidden duration-500 text-gray-200 lg:leading-snug lg:text-lg lg:max-w-[240px] xl:max-w-[270px]"
        }, section ? section === null || section === void 0 ? void 0 : section.description : null)), /*#__PURE__*/ React.createElement("img", {
            width: "202",
            height: "202",
            className: clsx("absolute z-10 opacity-0 group-hover:opacity-100 transition-all duration-300 w-[130px]", {
                "-top-[9px] sm:-top-[13px] -right-[8px] sm:-right-[11px] lg:right-[175px] sm:w-auto": (section === null || section === void 0 ? void 0 : section.imageQuadrant) === "northeast",
                "-top-[7px] sm:-top-[12px] -left-[9px] sm:-left-[13px] lg:left-[173px] sm:w-[202px]": (section === null || section === void 0 ? void 0 : section.imageQuadrant) === "northwest",
                "top-[178px] sm:top-[277px] -right-[9px] sm:-right-[13px] lg:right-[173px] sm:w-auto": (section === null || section === void 0 ? void 0 : section.imageQuadrant) === "southeast",
                "top-[179px] sm:top-[279px] -left-[8px] sm:-left-[11px] lg:left-[175px] sm:w-auto": (section === null || section === void 0 ? void 0 : section.imageQuadrant) === "southwest"
            }),
            src: "".concat(section === null || section === void 0 ? void 0 : section.image),
            alt: "".concat(section === null || section === void 0 ? void 0 : section.heading)
        }), (section === null || section === void 0 ? void 0 : section.imageQuadrant) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DiagramSegment, {
            imageQuadrant: section.imageQuadrant
        }), /*#__PURE__*/ React.createElement(SegmentDot, {
            imageQuadrant: section.imageQuadrant
        })));
    })))));
}
function MainDiagramSvg() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "468px",
        height: "467px",
        viewBox: "0 0 468 467",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: "mx-auto mb-8 lg:mb-0 relative sm:left-0 z-10 w-[300px] sm:w-[468px] h-auto"
    }, /*#__PURE__*/ React.createElement("title", null, "Lifecycle Graphic Step 1@1x"), /*#__PURE__*/ React.createElement("g", {
        id: "Content-Graphic-Storyboard-Flow",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Data-Science-Graphic:-Panel-1",
        transform: "translate(-486.000000, -246.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Infographic",
        transform: "translate(301.000000, 87.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Section/Workflow-Infographic",
        transform: "translate(0.000000, 160.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Lifecycle-Graphic-Step-1",
        transform: "translate(186.449730, 0.000000)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M232.55027,417.43838 C338.036657,417.43838 423.55027,331.924767 423.55027,226.43838 C423.55027,120.951992 338.036657,35.4383796 232.55027,35.4383796 C127.063883,35.4383796 41.5502703,120.951992 41.5502703,226.43838 C41.5502703,331.924767 127.063883,417.43838 232.55027,417.43838 Z",
        id: "Outline-Circle",
        stroke: "#A8A7A7",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeDasharray: "0,6"
    }), /*#__PURE__*/ React.createElement("g", {
        id: "Logo-Center-Circle",
        transform: "translate(82.550270, 76.000000)",
        stroke: "#FDD800"
    }, /*#__PURE__*/ React.createElement("circle", {
        id: "Highlight-Center-Circle",
        cx: "150",
        cy: "150",
        r: "150"
    })), /*#__PURE__*/ React.createElement("text", {
        id: "create",
        transform: "translate(63.550270, 226.000000) rotate(-90.000000) translate(-63.550270, -226.000000) ",
        fontFamily: "Figtree-Bold, Figtree",
        fontSize: "10",
        fontWeight: "bold",
        letterSpacing: "1",
        fill: "#201E1E"
    }, /*#__PURE__*/ React.createElement("tspan", {
        x: "41.5502703",
        y: "230"
    }, "CREATE")), /*#__PURE__*/ React.createElement("text", {
        id: "productionize",
        transform: "translate(401.550270, 231.000000) rotate(-270.000000) translate(-401.550270, -231.000000) ",
        fontFamily: "Figtree-Bold, Figtree",
        fontSize: "10",
        fontWeight: "bold",
        letterSpacing: "1",
        fill: "#A8A7A7"
    }, /*#__PURE__*/ React.createElement("tspan", {
        x: "354.05027",
        y: "235"
    }, "PRODUCTIONIZE")), /*#__PURE__*/ React.createElement("path", {
        d: "M172.550029,336.384377 L172.548051,464.876759 C88.213618,443.169711 21.8193236,376.775573 0.112053014,292.44123 L128.604273,292.438621 C139.14258,310.656113 154.332536,325.84607 172.550029,336.384377 Z M464.988487,292.44123 C443.281271,376.775363 376.887254,443.16938 292.553121,464.876597 L292.550511,336.384377 C310.768004,325.84607 325.95796,310.656113 336.496267,292.438621 Z M172.548051,-5.47990496e-14 L172.550029,128.492382 C154.332536,139.030689 139.14258,154.220646 128.604273,172.438139 L0.111890671,172.43616 C21.8189926,88.1015171 88.2134077,21.7071019 172.548051,-5.52980183e-14 Z M292.553121,0.000162342194 C376.887464,21.7074329 443.281602,88.1017273 464.98865,172.43616 L336.496267,172.438139 C325.95796,154.220646 310.768004,139.030689 292.550511,128.492382 Z",
        id: "Quarter-Circle-Tabs/Static",
        stroke: "#C0C3C5",
        fill: "#F7F9FB"
    }), /*#__PURE__*/ React.createElement("g", {
        id: "DSLC-Diagram",
        transform: "translate(112.550270, 178.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Diagram-Loop/Left",
        transform: "translate(72.765951, 54.000000) scale(-1, 1) translate(-72.765951, -54.000000) "
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0,78.778761 C11.6970997,66.0333529 19.3351589,56.4304291 22.9141776,49.9699895 C28.2827056,40.2793302 35.1002451,31.4982824 39.2321708,27.8088406 C39.2321708,27.8088406 41.2583127,27.8088406 45.3105965,27.8088406 L45.3105965,34.2580821 C40.0537313,40.1394978 35.2635285,47.1499683 30.9399883,55.2894937 C26.616448,63.4290191 18.1573872,73.8919655 5.56280595,86.678333 L8.25098505,77.3241845 L0,78.778761 Z",
        id: "Path-8",
        fill: "#F9F3D8"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M39.2321708,27.8088406 L45.1459299,27.8088406 L45.1459299,34.4464924 C60.3415734,17.2280494 76.1415364,8.61882785 92.5458188,8.61882785 C117.152242,8.61882785 131.354554,28.2179673 134.71524,39.4112717 C138.075927,50.604576 141.599731,81.4893818 108.608292,95.5635567 C91.785622,101.988732 75.5231433,99.049085 59.8208562,86.7446154 L64.3733171,81.9121789 L42.7534121,77.187276 L48.8503801,98.22475 L53.2882799,93.2730726 C67.0173208,103.873468 81.0829803,108.751265 95.4852583,107.906464 C117.088675,106.639263 134.73656,89.8587003 139.583881,79.459675 C144.665041,70.9313391 151.924206,42.7562614 134.71524,20.8062535 C117.782965,-1.44793246 90.4752823,-2.49463911 75.7427241,2.36816722 C63.9108874,5.55715071 51.740703,14.0373752 39.2321708,27.8088406 Z",
        id: "Path-7",
        fill: "#FDD800"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Diagram-Loop/Right",
        transform: "translate(94.468097, 0.000000)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0,78.778761 C11.6970997,66.0333529 19.3351589,56.4304291 22.9141776,49.9699895 C28.2827056,40.2793302 35.1002451,31.4982824 39.2321708,27.8088406 C39.2321708,27.8088406 41.2583127,27.8088406 45.3105965,27.8088406 L45.3105965,34.2580821 C40.0537313,40.1394978 35.2635285,47.1499683 30.9399883,55.2894937 C26.616448,63.4290191 18.1573872,73.8919655 5.56280595,86.678333 L8.25098505,77.3241845 L0,78.778761 Z",
        id: "Path-8",
        fill: "#F9F3D8"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M39.2321708,27.8088406 L45.1459299,27.8088406 L45.1459299,34.4464924 C60.3415734,17.2280494 76.1415364,8.61882785 92.5458188,8.61882785 C117.152242,8.61882785 131.354554,28.2179673 134.71524,39.4112717 C138.075927,50.604576 141.599731,81.4893818 108.608292,95.5635567 C91.785622,101.988732 75.5231433,99.049085 59.8208562,86.7446154 L64.3733171,81.9121789 L42.7534121,77.187276 L48.8503801,98.22475 L53.2882799,93.2730726 C67.0173208,103.873468 81.0829803,108.751265 95.4852583,107.906464 C117.088675,106.639263 134.73656,89.8587003 139.583881,79.459675 C144.665041,70.9313391 151.924206,42.7562614 134.71524,20.8062535 C117.782965,-1.44793246 90.4752823,-2.49463911 75.7427241,2.36816722 C63.9108874,5.55715071 51.740703,14.0373752 39.2321708,27.8088406 Z",
        id: "Path-7",
        fill: "#FDD800"
    }))), /*#__PURE__*/ React.createElement("circle", {
        id: "Connector-Dot",
        stroke: "#C0C3C5",
        fill: "#FFFFFF",
        cx: "408.55027",
        cy: "293.43838",
        r: "7.5"
    }), /*#__PURE__*/ React.createElement("circle", {
        id: "Connector-Dot",
        stroke: "#C0C0C0",
        fill: "#FFFFFF",
        cx: "171.55027",
        cy: "407.43838",
        r: "7.5"
    }), /*#__PURE__*/ React.createElement("circle", {
        id: "Connector-Dot",
        stroke: "#C0C3C5",
        fill: "#FFFFFF",
        cx: "49.5502703",
        cy: "172.43838",
        r: "7.5"
    }), /*#__PURE__*/ React.createElement("circle", {
        id: "Connector-Dot",
        stroke: "#C0C3C5",
        fill: "#FFFFFF",
        cx: "292.55027",
        cy: "46.4383796",
        r: "7.5"
    })))))));
}
function DiagramSegment(param) {
    var imageQuadrant = param.imageQuadrant;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("svg", {
        width: "57px",
        height: "121px",
        viewBox: "0 0 57 121",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: clsx("absolute opacity-0 group-hover:opacity-100 block transition-all duration-300 w-[36px] sm:w-auto", {
            "top-[90px] sm:top-[173px] right-[27px] sm:right-[43px] lg:right-[229px] rotate-[185deg]": imageQuadrant === "northeast",
            "-top-[19px] sm:top-[5px] left-[133px] sm:left-[207px] lg:left-[392px] rotate-[93deg]": imageQuadrant === "northwest",
            "top-[190px] sm:top-[330px] right-[132px] sm:right-[207px] lg:right-[392px] -rotate-[88deg]": imageQuadrant === "southeast",
            "top-[90px] sm:top-[173px] left-[27px] sm:left-[43px] lg:left-[229px]": imageQuadrant === "southwest"
        })
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Content-Graphic-Storyboard-Flow",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Data-Science-Graphic:-Panel-1",
        transform: "translate(-529.000000, -419.000000)",
        fill: "#F9F4EA"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Infographic",
        transform: "translate(301.000000, 87.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Section/Workflow-Infographic",
        transform: "translate(0.000000, 160.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Lifecycle-Graphic-Step-1",
        transform: "translate(186.449730, 0.000000)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M77.1892058,204.362448 C95.5784527,204.362448 113.360721,206.961233 130.188783,211.811575 L130.18902,254.994356 C113.710123,248.769105 95.8474981,245.362448 77.1892058,245.362448 C53.1088443,245.362448 30.3537813,251.036725 10.1881589,261.121137 L10.1862591,216.445183 C31.0351265,208.633923 53.613338,204.362448 77.1892058,204.362448 Z",
        id: "Highlight-Wedge",
        transform: "translate(70.187639, 232.741793) rotate(-90.000000) translate(-70.187639, -232.741793) "
    }))))))), /*#__PURE__*/ React.createElement("svg", {
        width: "57px",
        height: "121px",
        viewBox: "0 0 57 121",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: clsx("absolute opacity-0 group-hover:opacity-100 block transition-all duration-300 w-[36px] sm:w-auto", {
            hidden: imageQuadrant === "northeast" || imageQuadrant === "southwest",
            "top-[90px] sm:top-[173px] left-[27px] sm:left-[43px] lg:left-[229px]": imageQuadrant === "northwest",
            "top-[90px] sm:top-[173px] right-[27px] sm:right-[43px] lg:right-[229px] rotate-[185deg]": imageQuadrant === "southeast"
        })
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Content-Graphic-Storyboard-Flow",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Data-Science-Graphic:-Panel-1",
        transform: "translate(-529.000000, -419.000000)",
        fill: "#F9F4EA"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Infographic",
        transform: "translate(301.000000, 87.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Section/Workflow-Infographic",
        transform: "translate(0.000000, 160.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Lifecycle-Graphic-Step-1",
        transform: "translate(186.449730, 0.000000)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M77.1892058,204.362448 C95.5784527,204.362448 113.360721,206.961233 130.188783,211.811575 L130.18902,254.994356 C113.710123,248.769105 95.8474981,245.362448 77.1892058,245.362448 C53.1088443,245.362448 30.3537813,251.036725 10.1881589,261.121137 L10.1862591,216.445183 C31.0351265,208.633923 53.613338,204.362448 77.1892058,204.362448 Z",
        id: "Highlight-Wedge",
        transform: "translate(70.187639, 232.741793) rotate(-90.000000) translate(-70.187639, -232.741793) "
    }))))))));
}
function SegmentDot(param) {
    var imageQuadrant = param.imageQuadrant;
    return /*#__PURE__*/ React.createElement("svg", {
        className: clsx("absolute opacity-0 z-20 group-hover:opacity-100 transition-all duration-300 w-2.5 sm:w-4", {
            "top-[22px] sm:top-[39px] right-[107px] sm:right-[166px] lg:right-[352px]": imageQuadrant === "northeast",
            "top-[103px] sm:top-[165px] left-[28px] sm:left-[43px] lg:left-[229px]": imageQuadrant === "northwest",
            "top-[180px] sm:top-[286px] right-[32px] sm:right-[50px] lg:right-[236px]": imageQuadrant === "southeast",
            "top-[254px] sm:top-[400px] left-[106px] sm:left-[165px] lg:left-[351px]": imageQuadrant === "southwest"
        }),
        width: "16px",
        height: "17px",
        viewBox: "0 0 16 17",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Content-Graphic-Storyboard-Flow",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Data-Science-Graphic:-Panel-1",
        transform: "translate(-772.000000, -285.000000)",
        fill: "#D9D9D9",
        stroke: "#C0C3C5"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Infographic",
        transform: "translate(301.000000, 87.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Section/Workflow-Infographic",
        transform: "translate(0.000000, 160.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Lifecycle-Graphic-Step-1",
        transform: "translate(186.449730, 0.000000)"
    }, /*#__PURE__*/ React.createElement("circle", {
        id: "Connector-Dot",
        cx: "292.55027",
        cy: "46.4383796",
        r: "7.5"
    })))))));
}
